<template>
  <div>
    <section class="content-header mt-2">
      <h1 class="pull-left">
        <font-awesome-icon icon="database" />
        Connections
      </h1>
      <router-link
        class="btn btn-success pull-right"
        :to="{ name: 'connection.create' }">
        <font-awesome-icon icon="plus" />
      </router-link>
    </section>
    <error-component
      v-if="exceptions.length > 0"
      v-bind="exceptions[0]" />
    <success-component
      v-if="success.length > 0"
      :message="success" />
    <div class="content">
      <div v-if="loading">
        <bouncing-component />
      </div>
      <div v-else>
        <div
          v-if="pagination.totalRows > 0"
          class="">
          <b-table
            class="table table-striped"
            :items="connections"
            :fields="fields"
            stacked="sm">
            <template
              slot="status"
              slot-scope="row">
              <span
                v-if="row .item.status"
                v-b-tooltip.hover
                title="Connection successful"
                class="ml-3">
                <font-awesome-icon
                  icon="check-circle"
                  class="success" />
              </span>
              <span
                v-if="row.item.status === false"
                v-b-tooltip.hover
                title="Connection failed"
                class="ml-3">
                <font-awesome-icon
                  icon="times-circle"
                  class="failure" />
              </span>
              <b-spinner
                v-if="row.item.isRunning"
                small
                class="ml-3" />
            </template>
            <template
              slot="actions"
              slot-scope="row">
              <b-button-group class="">
                <router-link
                  v-b-tooltip.hover
                  class="btn btn-xs btn-primary"
                  title="Edit"
                  :to="{
                    name: 'connection.edit',
                    params: { connectionId: row.item.id }
                  }">
                  <font-awesome-icon icon="edit" />
                </router-link>
                <button
                  v-b-tooltip.hover
                  type="submit"
                  class="btn btn-danger btn-xs"
                  title="Delete"
                  @click.prevent="del(row.item.id, row.index)">
                  <font-awesome-icon icon="trash-alt" />
                </button>
              </b-button-group>
            </template>
          </b-table>
          <b-pagination
            v-model="pagination.currentPage"
            align="center"
            size="md"
            :total-rows="pagination.totalRows"
            :limit="pagination.limit"
            :per-page="pagination.limit"
            @change="change" />
        </div>
        <div
          v-else
          class="empty connection">
          <p>
            Start making your first connection.
          </p>
          <div>
            <router-link
              tag="button"
              class="btn btn-success"
              :to="{ name: 'connection.create' }">
              Add your first connection
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BouncingComponent from "../../components/Bouncing-loader.vue";
  import SuccessComponent from "../../components/Success.vue";
  import ErrorComponent from "../../components/ErrorView.vue";
  import { mapGetters, mapState } from "vuex";

  export default {
    name: "Connection",
    components: {
      SuccessComponent,
      ErrorComponent,
      BouncingComponent
    },
    data() {
      return {
        unwatch: "",
        loading: true,
        fields: ["name", "type", "status", "actions"]
      };
    },
    computed: {
      ...mapGetters({
        organizationSelected: "getOrganizationSelected"
      }),
      ...mapState("connections", {
        connections: "items",
        pagination: "pagination",
        connection: "connection"
      }),
      ...mapState({
        success: "success",
        exceptions: "exceptions"
      })
    },
    watch: {
      organizationSelected(val) {
        this.$store.commit("connections/SET_PAGINATION", {
          current_page: 1,
          total: 0
        });
        this.$store.dispatch("clearMessages");
        this.loading = true;
        this.$store.dispatch("connections/fetch")
          .then(() => {
            this.fetchStatus();
          })
          .finally(() => {
            this.loading = false;
          });
        this.$router.push({ name: "connection", query: { page: 1 } });
      }
    },
    beforeDestroy() {
      this.$store.commit("connections/SET_CONNECTIONS", []);
      this.$store.dispatch("clearMessages");

    },
    created() {
      let page = this.$route.query.page;
      if (page) {
        this.update(parseInt(page));
      } else {
        this.update(1);
      }
    },
    methods: {
      change(page) {
        this.update(page);
        this.$router.push({ name: "connection", query: { page: page } });
      },
      checkStatus(idConnection, index) {
        this.$store.commit("connections/SET_STATUS_LOADING", {
          running: true,
          index: index
        });
        this.$store
          .dispatch("connections/checkStatus", {
            slug: idConnection,
            index: index
          })
          .then(res => {
            this.$store.commit("connections/SET_STATUS_LOADING", {
              running: false,
              index: index
            });
          });
      },
      del(id, index) {
        this.$swal({
          title: "Be careful",
          text: "Are you sure?",
          type: "warning",
          width: "350px",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Confirm"
        }).then(result => {
          if (result.value) {
            this.$store
              .dispatch("connections/remove", { id: id, index: index })
              .then(() => {
                this.fetchStatus();
              });
          }
        });
      },
      fetchStatus() {
        for (let conn in this.connections) {
          this.checkStatus(this.connections[conn].id, conn);
        }
      },
      update(page) {
        this.$store.commit("connections/SET_CURRENT_PAGE", page);
        this.loading = true;
        this.$store.dispatch("connections/fetch")
          .then(() => {
            this.fetchStatus();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>

<style scoped>
.ld-ext-right.running {
  padding-left: 22px;
  padding-right: 0 !important;
}
</style>
